import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />,
  'ArrowForwardIos',
  '0 -960 960 960',
)
